
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

try {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error("Could not find root element to mount to");
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  console.error('Failed to initialize app:', error);
  document.body.innerHTML = `
    <div style="padding: 20px; font-family: system-ui; max-width: 800px; margin: 40px auto;">
      <h1 style="color: #ef4444;">Application Error</h1>
      <p style="background: #fee; padding: 15px; border-radius: 8px; border-left: 4px solid #ef4444;">
        ${error instanceof Error ? error.message : String(error)}
      </p>
      <p>Please check the browser console for more details.</p>
    </div>
  `;
}
